// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host { display: block; }

.rte-host {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.rte-wrapper {
  display: flex;
  flex-direction: column;
  border: 1px solid var(--app-ink-alpha-150);
  border-radius: 6px;
  overflow: hidden;
  transition: border-color 0.15s ease;
}

.rte-wrapper:focus-within {
  border-color: var(--mdc-outlined-text-field-focus-outline-color, var(--app-editor-link));
  border-width: 2px;
}

/* ── Toolbar ────────────────────────────────────────────────────────────── */

.rte-toolbar {
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 4px 8px;
  background: var(--app-legacy-canvas);
  border-bottom: 1px solid var(--app-ink-alpha-100);
}

.rte-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 30px;
  padding: 0;
  border: 1px solid transparent;
  border-radius: 4px;
  background: transparent;
  color: var(--app-ink-alpha-550);
  cursor: pointer;
  font-size: var(--app-font-size-18px);
  transition: background 0.15s, color 0.15s, opacity 0.15s;
}

.rte-btn:hover:not([disabled]) {
  background: var(--app-ink-alpha-70);
  color: var(--app-ink-alpha-870);
}

.rte-btn--active {
  background: var(--app-editor-link-alpha-120);
  color: var(--app-editor-link-hover);
}

.rte-btn--active:hover:not([disabled]) {
  background: var(--app-editor-link-alpha-220);
  color: var(--app-editor-link-active);
}

.rte-btn--danger {
  color: var(--app-editor-link-error);
}

.rte-btn[disabled] {
  opacity: 0.3;
  cursor: not-allowed;
}

.rte-divider {
  width: 1px;
  height: 20px;
  background: var(--app-ink-alpha-140);
  margin: 0 4px;
  flex-shrink: 0;
}

/* ── Link panel (slide-down empurrando textarea) ─────────────────────────── */

.rte-link-panel {
  display: grid;
  grid-template-rows: 0fr;
  overflow: hidden;
  transition: grid-template-rows 0.3s ease;
}

.rte-link-panel--open {
  grid-template-rows: 1fr;
}

.rte-link-panel__body {
  min-height: 0;
  overflow: hidden;
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 0 8px;
  background: var(--app-legacy-canvas);
  border-bottom: 1px solid transparent;
  transition: padding 0.3s ease, border-color 0.3s ease;
}

.rte-link-panel--open .rte-link-panel__body {
  padding: 6px 8px;
  border-bottom-color: var(--app-ink-alpha-100);
}

.rte-link-input {
  flex: 1;
  height: 28px;
  padding: 0 8px;
  font-size: var(--app-font-size-13px);
  border: 1px solid var(--app-ink-alpha-280);
  border-radius: 4px;
  outline: none;
  font-family: inherit;
  color: var(--app-ink-alpha-870);
  background: var(--app-white);
  transition: border-color 0.15s;
}

.rte-link-input:focus { border-color: var(--app-editor-link); }

.rte-link-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: var(--app-font-size-16px);
  transition: background 0.15s;
}

.rte-link-btn--confirm { background: var(--app-editor-link-hover); color: var(--app-white); }
.rte-link-btn--confirm:hover { background: var(--app-editor-link-active); }
.rte-link-btn--cancel { background: var(--app-ink-alpha-80); color: var(--app-ink-alpha-600); }
.rte-link-btn--cancel:hover { background: var(--app-ink-alpha-140); }

/* ── Link preview inline na toolbar ────────────────────────────────────── */

.rte-toolbar__link {
  display: flex;
  align-items: center;
  gap: 5px;
  overflow: hidden;
  max-width: 0;
  opacity: 0;
  transition: max-width 0.32s ease, opacity 0.25s ease;
  flex-shrink: 1;
}

.rte-toolbar__link--visible {
  max-width: 300px;
  opacity: 1;
}

.rte-toolbar__link-icon {
  color: var(--app-editor-link-hover);
  font-size: var(--app-font-size-14px);
  flex-shrink: 0;
}

.rte-toolbar__link-url {
  color: var(--app-editor-link-hover);
  font-size: var(--app-font-size-12px);
  text-decoration: underline;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
  max-width: 180px;
}

.rte-toolbar__link-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: var(--app-ink-alpha-550);
  cursor: pointer;
  font-size: var(--app-font-size-18px);
  flex-shrink: 0;
  transition: background 0.12s, color 0.12s;
}

.rte-toolbar__link-btn:hover { background: var(--app-ink-alpha-80); color: var(--app-ink-alpha-870); }
.rte-toolbar__link-btn--danger:hover { background: var(--app-editor-link-error-alpha-100); color: var(--app-editor-link-error); }

/* ── Área de edição ─────────────────────────────────────────────────────── */

.rte-editor {
  min-height: 200px;
  max-height: 70dvh;
  overflow-y: auto;
  padding: 1rem;
  outline: none;
  font-family: inherit;
  font-size: inherit;
  line-height: 1.6;
  color: var(--app-ink-alpha-870);
  background: var(--app-white);
  white-space: pre-wrap;
  word-break: break-word;
}

.rte-editor:empty::before {
  content: attr(data-placeholder);
  color: var(--app-ink-alpha-380);
  pointer-events: none;
}

/* Listas (requer ng-deep pois são inseridas dinamicamente via contenteditable) */
.rte-editor ::ng-deep ul,
.rte-editor ::ng-deep ol { padding-left: 1.5rem; margin: 4px 0; }
.rte-editor ::ng-deep li { margin-bottom: 2px; }

/* Listas com parênteses customizadas (a), A), i), I)) */
.rte-editor ::ng-deep ol.rte-list-alpha-paren,
.rte-editor ::ng-deep ol.rte-list-upper-alpha-paren,
.rte-editor ::ng-deep ol.rte-list-lower-roman-paren,
.rte-editor ::ng-deep ol.rte-list-upper-roman-paren {
  list-style: none !important;
  counter-reset: paren-counter;
}
.rte-editor ::ng-deep ol.rte-list-alpha-paren > li,
.rte-editor ::ng-deep ol.rte-list-upper-alpha-paren > li,
.rte-editor ::ng-deep ol.rte-list-lower-roman-paren > li,
.rte-editor ::ng-deep ol.rte-list-upper-roman-paren > li {
  counter-increment: paren-counter;
}
.rte-editor ::ng-deep ol.rte-list-alpha-paren > li::before,
.rte-editor ::ng-deep ol.rte-list-upper-alpha-paren > li::before,
.rte-editor ::ng-deep ol.rte-list-lower-roman-paren > li::before,
.rte-editor ::ng-deep ol.rte-list-upper-roman-paren > li::before {
  display: inline-block;
  box-sizing: border-box;
  width: 1.5rem;
  margin-left: -1.5rem;
  padding-right: 0.1rem;
  text-align: right;
}
.rte-editor ::ng-deep ol.rte-list-alpha-paren > li::before {
  content: counter(paren-counter, lower-alpha) ") ";
}
.rte-editor ::ng-deep ol.rte-list-upper-alpha-paren > li::before {
  content: counter(paren-counter, upper-alpha) ") ";
}
.rte-editor ::ng-deep ol.rte-list-lower-roman-paren > li::before {
  content: counter(paren-counter, lower-roman) ") ";
}
.rte-editor ::ng-deep ol.rte-list-upper-roman-paren > li::before {
  content: counter(paren-counter, upper-roman) ") ";
}

/* Listas numéricas com parêntese e ordinais (1), 1º, 1ª) */
.rte-editor ::ng-deep ol.rte-list-decimal-paren,
.rte-editor ::ng-deep ol.rte-list-decimal-ordm,
.rte-editor ::ng-deep ol.rte-list-decimal-ordf {
  list-style: none !important;
  counter-reset: paren-counter;
}
.rte-editor ::ng-deep ol.rte-list-decimal-paren > li,
.rte-editor ::ng-deep ol.rte-list-decimal-ordm > li,
.rte-editor ::ng-deep ol.rte-list-decimal-ordf > li {
  counter-increment: paren-counter;
}
.rte-editor ::ng-deep ol.rte-list-decimal-paren > li::before,
.rte-editor ::ng-deep ol.rte-list-decimal-ordm > li::before,
.rte-editor ::ng-deep ol.rte-list-decimal-ordf > li::before {
  display: inline-block;
  box-sizing: border-box;
  width: 1.5rem;
  margin-left: -1.5rem;
  padding-right: 0.1rem;
  text-align: right;
}
.rte-editor ::ng-deep ol.rte-list-decimal-paren > li::before {
  content: counter(paren-counter) ") ";
}
.rte-editor ::ng-deep ol.rte-list-decimal-ordm > li::before {
  content: counter(paren-counter) "º ";
}
.rte-editor ::ng-deep ol.rte-list-decimal-ordf > li::before {
  content: counter(paren-counter) "ª ";
}

.rte-editor a { color: var(--app-editor-link-hover); text-decoration: underline; word-break: break-all; cursor: pointer; }
.rte-editor a:hover { color: var(--app-editor-link-active); }

.rte-wrapper:has(.rte-editor--error) { border-color: var(--app-editor-error); }

/* ── Rodapé ─────────────────────────────────────────────────────────────── */

.rte-footer {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  padding: 2px 2px 0;
  min-height: 20px;
}

.rte-errors { flex: 1; }

.rte-error {
  font-size: var(--app-font-size-caption-relative);
  color: var(--app-editor-error);
  letter-spacing: 0.4px;
  line-height: 1.4;
}

.rte-counter {
  margin-left: auto;
  font-size: var(--app-font-size-caption-relative);
  color: var(--app-ink-alpha-420);
  white-space: nowrap;
  letter-spacing: 0.3px;
}

.rte-counter--error { color: var(--app-editor-error); }

.rte-editor ::ng-deep p { margin: 0; }
.rte-editor ::ng-deep .rte-list-separator { height: 0; overflow: hidden; }

.rte-editor { min-height: 120px; }

.rte-compact .rte-editor { min-height: 80px; }
`, "",{"version":3,"sources":["webpack://./src/app/shared/components/rich-text-editor/rich-text-editor.component.css"],"names":[],"mappings":"AAAA,QAAQ,cAAc,EAAE;;AAExB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,wFAAwF;EACxF,iBAAiB;AACnB;;AAEA,8EAA8E;;AAE9E;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,oCAAoC;EACpC,iDAAiD;AACnD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,6BAA6B;EAC7B,kBAAkB;EAClB,uBAAuB;EACvB,+BAA+B;EAC/B,eAAe;EACf,oCAAoC;EACpC,wDAAwD;AAC1D;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,4CAA4C;EAC5C,mCAAmC;AACrC;;AAEA;EACE,4CAA4C;EAC5C,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,cAAc;AAChB;;AAEA,+EAA+E;;AAE/E;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,oCAAoC;EACpC,oCAAoC;EACpC,qDAAqD;AACvD;;AAEA;EACE,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,cAAc;EACd,oCAAoC;EACpC,0CAA0C;EAC1C,kBAAkB;EAClB,aAAa;EACb,oBAAoB;EACpB,+BAA+B;EAC/B,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA,wBAAwB,oCAAoC,EAAE;;AAE9D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA,yBAAyB,wCAAwC,EAAE,uBAAuB,EAAE;AAC5F,+BAA+B,yCAAyC,EAAE;AAC1E,wBAAwB,mCAAmC,EAAE,+BAA+B,EAAE;AAC9F,8BAA8B,oCAAoC,EAAE;;AAEpE,6EAA6E;;AAE7E;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,oDAAoD;EACpD,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;EACpC,0BAA0B;EAC1B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,+BAA+B;EAC/B,eAAe;EACf,oCAAoC;EACpC,cAAc;EACd,yCAAyC;AAC3C;;AAEA,+BAA+B,mCAAmC,EAAE,+BAA+B,EAAE;AACrG,uCAAuC,kDAAkD,EAAE,mCAAmC,EAAE;;AAEhI,8EAA8E;;AAE9E;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,4BAA4B;EAC5B,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA,iFAAiF;AACjF;2BAC2B,oBAAoB,EAAE,aAAa,EAAE;AAChE,2BAA2B,kBAAkB,EAAE;;AAE/C,wDAAwD;AACxD;;;;EAIE,2BAA2B;EAC3B,4BAA4B;AAC9B;AACA;;;;EAIE,gCAAgC;AAClC;AACA;;;;EAIE,qBAAqB;EACrB,sBAAsB;EACtB,aAAa;EACb,oBAAoB;EACpB,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,iDAAiD;AACnD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,iDAAiD;AACnD;;AAEA,2DAA2D;AAC3D;;;EAGE,2BAA2B;EAC3B,4BAA4B;AAC9B;AACA;;;EAGE,gCAAgC;AAClC;AACA;;;EAGE,qBAAqB;EACrB,sBAAsB;EACtB,aAAa;EACb,oBAAoB;EACpB,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;;AAEA,gBAAgB,mCAAmC,EAAE,0BAA0B,EAAE,qBAAqB,EAAE,eAAe,EAAE;AACzH,sBAAsB,oCAAoC,EAAE;;AAE5D,uCAAuC,qCAAqC,EAAE;;AAE9E,8EAA8E;;AAE9E;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,cAAc,OAAO,EAAE;;AAEvB;EACE,gDAAgD;EAChD,8BAA8B;EAC9B,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gDAAgD;EAChD,+BAA+B;EAC/B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,sBAAsB,8BAA8B,EAAE;;AAEtD,0BAA0B,SAAS,EAAE;AACrC,4CAA4C,SAAS,EAAE,gBAAgB,EAAE;;AAEzE,cAAc,iBAAiB,EAAE;;AAEjC,2BAA2B,gBAAgB,EAAE","sourcesContent":[":host { display: block; }\n\n.rte-host {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.rte-wrapper {\n  display: flex;\n  flex-direction: column;\n  border: 1px solid var(--app-ink-alpha-150);\n  border-radius: 6px;\n  overflow: hidden;\n  transition: border-color 0.15s ease;\n}\n\n.rte-wrapper:focus-within {\n  border-color: var(--mdc-outlined-text-field-focus-outline-color, var(--app-editor-link));\n  border-width: 2px;\n}\n\n/* ── Toolbar ────────────────────────────────────────────────────────────── */\n\n.rte-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  padding: 4px 8px;\n  background: var(--app-legacy-canvas);\n  border-bottom: 1px solid var(--app-ink-alpha-100);\n}\n\n.rte-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 30px;\n  padding: 0;\n  border: 1px solid transparent;\n  border-radius: 4px;\n  background: transparent;\n  color: var(--app-ink-alpha-550);\n  cursor: pointer;\n  font-size: var(--app-font-size-18px);\n  transition: background 0.15s, color 0.15s, opacity 0.15s;\n}\n\n.rte-btn:hover:not([disabled]) {\n  background: var(--app-ink-alpha-70);\n  color: var(--app-ink-alpha-870);\n}\n\n.rte-btn--active {\n  background: var(--app-editor-link-alpha-120);\n  color: var(--app-editor-link-hover);\n}\n\n.rte-btn--active:hover:not([disabled]) {\n  background: var(--app-editor-link-alpha-220);\n  color: var(--app-editor-link-active);\n}\n\n.rte-btn--danger {\n  color: var(--app-editor-link-error);\n}\n\n.rte-btn[disabled] {\n  opacity: 0.3;\n  cursor: not-allowed;\n}\n\n.rte-divider {\n  width: 1px;\n  height: 20px;\n  background: var(--app-ink-alpha-140);\n  margin: 0 4px;\n  flex-shrink: 0;\n}\n\n/* ── Link panel (slide-down empurrando textarea) ─────────────────────────── */\n\n.rte-link-panel {\n  display: grid;\n  grid-template-rows: 0fr;\n  overflow: hidden;\n  transition: grid-template-rows 0.3s ease;\n}\n\n.rte-link-panel--open {\n  grid-template-rows: 1fr;\n}\n\n.rte-link-panel__body {\n  min-height: 0;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 0 8px;\n  background: var(--app-legacy-canvas);\n  border-bottom: 1px solid transparent;\n  transition: padding 0.3s ease, border-color 0.3s ease;\n}\n\n.rte-link-panel--open .rte-link-panel__body {\n  padding: 6px 8px;\n  border-bottom-color: var(--app-ink-alpha-100);\n}\n\n.rte-link-input {\n  flex: 1;\n  height: 28px;\n  padding: 0 8px;\n  font-size: var(--app-font-size-13px);\n  border: 1px solid var(--app-ink-alpha-280);\n  border-radius: 4px;\n  outline: none;\n  font-family: inherit;\n  color: var(--app-ink-alpha-870);\n  background: var(--app-white);\n  transition: border-color 0.15s;\n}\n\n.rte-link-input:focus { border-color: var(--app-editor-link); }\n\n.rte-link-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: var(--app-font-size-16px);\n  transition: background 0.15s;\n}\n\n.rte-link-btn--confirm { background: var(--app-editor-link-hover); color: var(--app-white); }\n.rte-link-btn--confirm:hover { background: var(--app-editor-link-active); }\n.rte-link-btn--cancel { background: var(--app-ink-alpha-80); color: var(--app-ink-alpha-600); }\n.rte-link-btn--cancel:hover { background: var(--app-ink-alpha-140); }\n\n/* ── Link preview inline na toolbar ────────────────────────────────────── */\n\n.rte-toolbar__link {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  overflow: hidden;\n  max-width: 0;\n  opacity: 0;\n  transition: max-width 0.32s ease, opacity 0.25s ease;\n  flex-shrink: 1;\n}\n\n.rte-toolbar__link--visible {\n  max-width: 300px;\n  opacity: 1;\n}\n\n.rte-toolbar__link-icon {\n  color: var(--app-editor-link-hover);\n  font-size: var(--app-font-size-14px);\n  flex-shrink: 0;\n}\n\n.rte-toolbar__link-url {\n  color: var(--app-editor-link-hover);\n  font-size: var(--app-font-size-12px);\n  text-decoration: underline;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  cursor: pointer;\n  max-width: 180px;\n}\n\n.rte-toolbar__link-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 30px;\n  border: none;\n  border-radius: 4px;\n  background: transparent;\n  color: var(--app-ink-alpha-550);\n  cursor: pointer;\n  font-size: var(--app-font-size-18px);\n  flex-shrink: 0;\n  transition: background 0.12s, color 0.12s;\n}\n\n.rte-toolbar__link-btn:hover { background: var(--app-ink-alpha-80); color: var(--app-ink-alpha-870); }\n.rte-toolbar__link-btn--danger:hover { background: var(--app-editor-link-error-alpha-100); color: var(--app-editor-link-error); }\n\n/* ── Área de edição ─────────────────────────────────────────────────────── */\n\n.rte-editor {\n  min-height: 200px;\n  max-height: 70dvh;\n  overflow-y: auto;\n  padding: 1rem;\n  outline: none;\n  font-family: inherit;\n  font-size: inherit;\n  line-height: 1.6;\n  color: var(--app-ink-alpha-870);\n  background: var(--app-white);\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.rte-editor:empty::before {\n  content: attr(data-placeholder);\n  color: var(--app-ink-alpha-380);\n  pointer-events: none;\n}\n\n/* Listas (requer ng-deep pois são inseridas dinamicamente via contenteditable) */\n.rte-editor ::ng-deep ul,\n.rte-editor ::ng-deep ol { padding-left: 1.5rem; margin: 4px 0; }\n.rte-editor ::ng-deep li { margin-bottom: 2px; }\n\n/* Listas com parênteses customizadas (a), A), i), I)) */\n.rte-editor ::ng-deep ol.rte-list-alpha-paren,\n.rte-editor ::ng-deep ol.rte-list-upper-alpha-paren,\n.rte-editor ::ng-deep ol.rte-list-lower-roman-paren,\n.rte-editor ::ng-deep ol.rte-list-upper-roman-paren {\n  list-style: none !important;\n  counter-reset: paren-counter;\n}\n.rte-editor ::ng-deep ol.rte-list-alpha-paren > li,\n.rte-editor ::ng-deep ol.rte-list-upper-alpha-paren > li,\n.rte-editor ::ng-deep ol.rte-list-lower-roman-paren > li,\n.rte-editor ::ng-deep ol.rte-list-upper-roman-paren > li {\n  counter-increment: paren-counter;\n}\n.rte-editor ::ng-deep ol.rte-list-alpha-paren > li::before,\n.rte-editor ::ng-deep ol.rte-list-upper-alpha-paren > li::before,\n.rte-editor ::ng-deep ol.rte-list-lower-roman-paren > li::before,\n.rte-editor ::ng-deep ol.rte-list-upper-roman-paren > li::before {\n  display: inline-block;\n  box-sizing: border-box;\n  width: 1.5rem;\n  margin-left: -1.5rem;\n  padding-right: 0.1rem;\n  text-align: right;\n}\n.rte-editor ::ng-deep ol.rte-list-alpha-paren > li::before {\n  content: counter(paren-counter, lower-alpha) \") \";\n}\n.rte-editor ::ng-deep ol.rte-list-upper-alpha-paren > li::before {\n  content: counter(paren-counter, upper-alpha) \") \";\n}\n.rte-editor ::ng-deep ol.rte-list-lower-roman-paren > li::before {\n  content: counter(paren-counter, lower-roman) \") \";\n}\n.rte-editor ::ng-deep ol.rte-list-upper-roman-paren > li::before {\n  content: counter(paren-counter, upper-roman) \") \";\n}\n\n/* Listas numéricas com parêntese e ordinais (1), 1º, 1ª) */\n.rte-editor ::ng-deep ol.rte-list-decimal-paren,\n.rte-editor ::ng-deep ol.rte-list-decimal-ordm,\n.rte-editor ::ng-deep ol.rte-list-decimal-ordf {\n  list-style: none !important;\n  counter-reset: paren-counter;\n}\n.rte-editor ::ng-deep ol.rte-list-decimal-paren > li,\n.rte-editor ::ng-deep ol.rte-list-decimal-ordm > li,\n.rte-editor ::ng-deep ol.rte-list-decimal-ordf > li {\n  counter-increment: paren-counter;\n}\n.rte-editor ::ng-deep ol.rte-list-decimal-paren > li::before,\n.rte-editor ::ng-deep ol.rte-list-decimal-ordm > li::before,\n.rte-editor ::ng-deep ol.rte-list-decimal-ordf > li::before {\n  display: inline-block;\n  box-sizing: border-box;\n  width: 1.5rem;\n  margin-left: -1.5rem;\n  padding-right: 0.1rem;\n  text-align: right;\n}\n.rte-editor ::ng-deep ol.rte-list-decimal-paren > li::before {\n  content: counter(paren-counter) \") \";\n}\n.rte-editor ::ng-deep ol.rte-list-decimal-ordm > li::before {\n  content: counter(paren-counter) \"º \";\n}\n.rte-editor ::ng-deep ol.rte-list-decimal-ordf > li::before {\n  content: counter(paren-counter) \"ª \";\n}\n\n.rte-editor a { color: var(--app-editor-link-hover); text-decoration: underline; word-break: break-all; cursor: pointer; }\n.rte-editor a:hover { color: var(--app-editor-link-active); }\n\n.rte-wrapper:has(.rte-editor--error) { border-color: var(--app-editor-error); }\n\n/* ── Rodapé ─────────────────────────────────────────────────────────────── */\n\n.rte-footer {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 2px 2px 0;\n  min-height: 20px;\n}\n\n.rte-errors { flex: 1; }\n\n.rte-error {\n  font-size: var(--app-font-size-caption-relative);\n  color: var(--app-editor-error);\n  letter-spacing: 0.4px;\n  line-height: 1.4;\n}\n\n.rte-counter {\n  margin-left: auto;\n  font-size: var(--app-font-size-caption-relative);\n  color: var(--app-ink-alpha-420);\n  white-space: nowrap;\n  letter-spacing: 0.3px;\n}\n\n.rte-counter--error { color: var(--app-editor-error); }\n\n.rte-editor ::ng-deep p { margin: 0; }\n.rte-editor ::ng-deep .rte-list-separator { height: 0; overflow: hidden; }\n\n.rte-editor { min-height: 120px; }\n\n.rte-compact .rte-editor { min-height: 80px; }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
